import React, { useContext, useEffect, useRef, useState } from 'react'
import SvgMoreOptionsIcon from 'assets/icons/MoreOptions'
import styled, { ThemeContext } from 'styled-components'
import Box from '../Box'
import Button from '../Button'
import { ActionType } from './Column'
import Triangle from 'assets/icons/dropdown-triangle.svg'
import useClickOutside from 'shared/hooks/useClickOutside'

type MoreOptionsProps<T = any> = {
  row: T
  hiddenText?: string
  isHidden?: (arg: T) => boolean
  actions: ActionType<T>[]
  fill?: string
  width?: string
}

const MoreOptions: React.FC<MoreOptionsProps> = (props: MoreOptionsProps) => {
  const { row, actions, width, fill = undefined, isHidden = (arg: any) => false, hiddenText = '' } = props
  const [isOpened, setIsOpened] = useState(false)
  const optionsRef = useRef(null)
  const theme = useContext(ThemeContext)

  useClickOutside(optionsRef, () => setIsOpened(false))
  useEffect(() => {
  }, [isHidden, hiddenText, row])
  return (
    <MoreOptionsContainer ref={optionsRef}>
      {isHidden(row) && (
          <HiddenText>{hiddenText}</HiddenText>
      )}
      {!isHidden(row) && (
        <>
          <Button
            height="fit-content"
            padding="5px"
            onClick={(e: MouseEvent) => {
              e.stopPropagation()
              setIsOpened(!isOpened)
            }}
          >
            <SvgMoreOptionsIcon fill={isOpened ? theme.colors.main : fill} />
          </Button>
          {isOpened && (
            <MoreOptionsDropdown $width={width} className="more-options-item-container">
              {actions.map(({ color, onClick, label, conditionalRendering = arg => true }) => {
                if (!conditionalRendering(row)) {
                  return null
                }

                return (
                  <MoreOptionsItem
                    key={label}
                    color={color}
                    onClick={e => {
                      e.stopPropagation()
                      return onClick !== undefined ? onClick(row) : null
                    }}
                  >
                    {label}
                  </MoreOptionsItem>
                )
              })}
            </MoreOptionsDropdown>
          )}
        </>
      )}
    </MoreOptionsContainer>
  )
}

const MoreOptionsContainer = styled(Box)`
  position: relative;
  width: fit-content;
  height: fit-content;
`

const HiddenText = styled(Box)`
  opacity: 0.6;
`

const MoreOptionsDropdown = styled(Box)<{ $width?: string }>`
  position: absolute;
  min-width: ${({ theme, $width }) => $width || '200px'};
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 5px;
  z-index: 1;
  box-shadow: 0px 0px 6px rgba(53, 53, 53, 0.2);
  top: 45px;
  right: -12px;
  padding: 10px;
  white-space: nowrap;

  &:before {
    content: '';
    width: 15px;
    height: 10px;
    position: absolute;
    right: 20px;
    top: -10px;
    background: url(${Triangle}) no-repeat;
  }
`
const MoreOptionsItem = styled(Box)<{ color?: string }>`
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
  cursor: pointer;
  color: ${({ color, theme }) => color ?? theme.colors.black};

  &:hover {
    color: ${({ theme, color }) => color ?? theme.colors.main};
  }
`

export default MoreOptions
